import { CONSTANT } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { PROD_DOMAIN, STAGING_DOMAIN, DEMO_DOMAIN, TEST_DOMAIN, TRIAL_DOMAIN } from "./environment";

/**
 * API URL取得用キー
 */

/**
 * 共通
 */
// ログインユーザ情報取得
export const USER_AUTHINFOS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/userauthinfos/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/userauthinfos/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/userauthinfos/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/userauthinfos/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/userauthinfos/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/userauthinfos/",
);
// ヘッダー項目生成
export const HEADER_LIST = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/headerlist/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/headerlist/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/headerlist/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/headerlist/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/headerlist/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/headerlist/",
);
// バリデーションチェック
export const API_URL_VALIDATION_RESULT = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/validationresult/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/validationresult/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/validationresult/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/validationresult/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/validationresult/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/validationresult/",
);
// バリデーションチェック(複数)
export const API_URL_MULTIVALIDATION_RESULT = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/multivalidationresult/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/multivalidationresult/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/multivalidationresult/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/multivalidationresult/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/multivalidationresult/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/multivalidationresult/",
);

// ブロック実行必要回数の取得
export const API_URL_RUN_COUNT = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/runcount/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/runcount/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/runcount/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/runcount/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/runcount/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/runcount/",
);

// ブロック実行必要回数の取得
export const API_URL_RUN_COUNT_PUB = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/runcountpub/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/runcountpub/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/runcountpub/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/runcountpub/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/runcountpub/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/runcountpub/",
);

// 全辞書値取得
export const API_URL_DIC_LISTS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/spec_code_masters/list/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/spec_code_masters/list/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/spec_code_masters/list/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/spec_code_masters/list/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/spec_code_masters/list/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/spec_code_masters/list/",
);

// ファイルアップロード（JOB登録）
export const API_URL_APPLICATIONS_FILES = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/applications/files/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/applications/files/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/applications/files/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/applications/files/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/applications/files/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/applications/files/",
);

// 郵便番号マスタ一覧
export const POSTALS_LIST = getUrl(
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/postals/list/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/postals/list/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/postals/list/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/postals/list/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/postals/list/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/postals/list/",
);

// 会員申請登録
export const APPLICATIONS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/applications/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/applications/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/applications/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/applications/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/applications/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/applications/",
);

// 確認コードチェック（会員プロフィール、ユーザへの分離作成）
export const AUTH_CODES = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/authcodes/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/authcodes/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/authcodes/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/authcodes/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/authcodes/",
);

// 認証コード再送信
export const AUTH_CODES_SEND = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/authcodes/send",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/authcodes/send/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/authcodes/send/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/authcodes/send/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/authcodes/send/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/authcodes/send/",
);

// メールアドレス入力チェック
export const EMAIL_CHECKS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/emailchecks/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/emailchecks/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/emailchecks/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/emailchecks/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/emailchecks/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/emailchecks/",
);

// パスワード設定
export const PASSWORDS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/passwords/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/passwords/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/passwords/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/passwords/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/passwords/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/passwords/",
);

// 入会申請詳細
export const APPLICATIONS_DETAIL = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/applications/detail/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/applications/detail/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/applications/detail/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/applications/detail/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/applications/detail/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/applications/detail/",
);


// 未承認一覧(入会申請承認)
export const APPLICATIONS_APPROVE = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/applications/approve/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/applications/approve/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/applications/approve/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/applications/approve/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/applications/approve/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/applications/approve/",
);

// カテゴリ一覧取得
export const AGENDA_CATEGORY_LIST = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_category/list/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/agenda_category/list/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_category/list/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/list/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_category/list/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_category/list/",
);

// 新着情報一覧
export const WHAT_SNEWS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/whatsnews/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/whatsnews/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/whatsnews/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/whatsnews/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/whatsnews/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/whatsnews/",
);

// 課題・ソリューション一覧
export const AGENDA_SOLUTIONS_LIST = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/agenda_solutions/list",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/mypage/agenda_solutions/list",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/agenda_solutions/list",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/agenda_solutions/list",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/agenda_solutions/list",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/agenda_solutions/list",
);

export const PUB_AGENDA_SOLUTIONS_LIST = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/agenda_solutions_pub/list",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/mypage/agenda_solutions_pub/list",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/agenda_solutions_pub/list",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/agenda_solutions_pub/list",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/agenda_solutions_pub/list",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/agenda_solutions_pub/list",
);

// addtition image to url of test
export const AGENDA_NEEDS_LIST = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/agenda_needs/list/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/mypage/agenda_needs/list/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/agenda_needs/list/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/agenda_needs/list/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/agenda_needs/list/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/agenda_needs/list/",
);

// 課題・ソリューション詳細
export const LOGIN_NOT_AGENDA_SOLUTIONS = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/",
);

// 課題・ソリューション詳細
export const LOGIN_NOT_AGENDA_SOLUTIONS_PUB = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions_pub/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions_pub/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions_pub/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions_pub/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions_pub/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions_pub/",
);


// 課題・ソリューション登録・更新
export const LOGIN_DONE_AGENDA_SOLUTIONS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/",
);

// 課題・ソリューション承認
export const AGENDA_SOLUTIONS_APPROVE = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/approve/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/approve/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/approve/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/approve/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/approve/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/approve/",
);

// 課題・ソリューション件数取得
export const AGENDA_CATEGORY_COUNT = getUrl(
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_category/count/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/agenda_category/count/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_category/count/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_category/count/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_category/count/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_category/count/",
);


// 掲示板コメント(GET:取得 POST:登録 DELETE:削除)
export const BOARDS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/boards/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/boards/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/boards/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/boards/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/boards/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/boards/",
);

// 掲示板コメント削除(DELETE:削除)
export const DELETE_BOARDS = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/boards/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/boards/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/boards/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/boards/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/boards/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/boards/",
);

// 掲示板コメント件数取得
export const BOARDS_COUNT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/boards/count/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/boards/count/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/boards/count/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/boards/count/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/boards/count/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/boards/count/",
);

// マッチングリスト取得
export const AGENDA_SOLUTIONS_SUGGEST = getUrl(
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/suggest/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/suggest/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/suggest/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/suggest/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/suggest/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/suggest/",
);

// チャットリスト取得
export const CHAT_LIST = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/chat/list/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/chat/list/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/chat/list/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/chat/list/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/chat/list/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/chat/list/",
);

// 会員一覧取得
export const MEMBERS_LIST = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/members/list",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/members/list",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/members/list",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/members/list",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/members/list",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/members/list",
);

// 会員の件数取得
export const MEMBER_COUNT = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/members/count",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/members/count",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/members/count",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/members/count",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/members/count",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/members/count",
);

// 会員プロファイル更新
export const MEMBER_INFO_UPDATE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/member/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/member/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/member/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/member/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/member/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/member/",
);

// 会員プロフィール詳細
export const MEMBERS_DETAIL = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/members/detail/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/members/detail/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/members/detail/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/members/detail/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/members/detail/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/members/detail/",
);

export const MEMBERS_DETAIL_MASTER = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/member/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/member/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/member/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/member/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/member/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/member/",
);

// 会員プロフィール詳細課題一覧
export const MEMBERS_AGENDA = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/members/agenda/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/members/agenda/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/members/agenda/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/members/agenda/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/members/agenda/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/members/agenda/",
);

// 会員プロフィール詳細 前回情報
export const MEMBERS_DETAIL_LOG = getUrl(
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
  "https://q5nmvdwxkj.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
  "https://q5nmvdwxkjzxc.execute-api.ap-northeast-1.amazonaws.com/dev/member_logs/detail/",
);

// ユーザ一覧取得
export const USER_LIST = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザ一覧詳細
export const USER_GENERATE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザ登録
export const USER_ADD = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザ編集
export const USER_EDIT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザ編集
export const USER_DELETE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザ編集 master
export const USER_DELETE_MASTER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users_master/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users_master/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users_master/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users_master/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users_master/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users_master/",
);


// 未承認入会申請一覧
export const UNAPPROVE_APPLICATION_LIST = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/unapproves/application",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/unapproves/application",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/unapproves/application",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/application",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/unapproves/application",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/unapproves/application",
);

// 未承認件数取得
export const UNAPPROVES_COUNT = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/unapproves/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/unapproves/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/unapproves/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/unapproves/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/unapproves/",
);

// 未承認一覧（提案）
export const UNAPPROVES_SUGGEST_LIST = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/unapproves/suggest",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/unapproves/suggest",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/unapproves/suggest",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/suggest",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/unapproves/suggest",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/unapproves/suggest",
);

// 未承認一覧(課題・ソリューション)
export const UNAPPROVES_AGENDA_SOLUTION = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/unapproves/agenda_solution",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/unapproves/agenda_solution",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/unapproves/agenda_solution",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/unapproves/agenda_solution",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/unapproves/agenda_solution",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/unapproves/agenda_solution",
);

// 課題・ソリューションマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_AGENDA_SOLUTION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/list",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/list",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/list",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/list",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/list",
);

// 検索項目取得／検索画面(GET)
export const API_URL_SEARCH_AGENDA_SOLUTION = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchagendasolutions/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/searchagendasolutions/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchagendasolutions/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchagendasolutions/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchagendasolutions/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchagendasolutions/",
);

// ユーザーマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_USER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users_master/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users_master/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users_master/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users_master/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users_master/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users_master/",
);
// ユーザーマスタ管理／REST API(GET:一覧/GET:詳細)
export const API_URL_USER_DUPLICATE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/users/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/users/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/users/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/users/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/users/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/users/",
);

// ユーザーマスタ管理／検索画面(GET)
export const API_URL_SEARCH_USER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/searchusers/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/searchusers/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/searchusers/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/searchusers/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/searchusers/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/searchusers/",
);

// お知らせ一覧取得
export const INFORMATION_LIST = getUrl(
"https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/information/list",
"https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/information/list",
"https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/information/list",
"https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/information/list",
"https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/information/list",
"https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/information/list",
);

// E002 
// お知らせ一覧取得
export const INFORMATION = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/information/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/information/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/information/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/information/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/information/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/information/",
);


// お知らせ詳細
export const INFORMATION_DETAIL = getUrl(
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/informations/detail/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/informations/detail/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/informations/detail/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/informations/detail/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/informations/detail/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/informations/detail/",
);

// お知らせ登録
export const INFORMATION_INSERT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/informations/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/informations/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/informations/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/informations/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/informations/",
);

// 会員プロフィール申請
export const MEMBERS_PROFILE_APPROVE = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/members/approve/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/members/approve/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/members/approve/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/members/approve/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/members/approve/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/members/approve/",
);

// 会員プロフィール未登録項目チェック(GET)
export const NEEDINPUT_STATUS = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/inputchecks/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/inputchecks/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/inputchecks/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/inputchecks/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/inputchecks/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/inputchecks/",
);

export const API_URL_INFORMATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
  "https://o5rmculti2zxc.execute-api.ap-northeast-1.amazonaws.com/dev/informations/",
);

export const API_URL_AGENDA = getUrl(
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://lwyjs61ai5.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
  "https://lwyjs61ai5zxc.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/list/",
);

export const API_URL_INPUT_MASTER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/inputitems",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/inputitems",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/inputitems",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/inputitems",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/inputitems",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/inputitems",
);

export const API_URL_AGENDA_SOLUTION_DETAIL = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions_master/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions_master/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions_master/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions_master/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions_master/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions_master/",
);

// Nga add
export const API_URL_AGENDA_SOLUTION_ADD = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/",
);
// Nga add
export const API_URL_AGENDA_SOLUTION_DELETE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/",
);
export const API_URL_AGENDA_SOLUTION_DUPLICATE = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_solutions/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_solutions/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_solutions/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_solutions/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_solutions/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_solutions/",
);

export const API_URL_AGENDA_NEED_LIST = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs/list/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs/list/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs/list/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs/list/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs/list/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs/list/",
);
export const API_URL_AGENDA_NEED_SEARCH = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchagendaneeds/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/searchagendaneeds/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchagendaneeds/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchagendaneeds/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchagendaneeds/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchagendaneeds/",
);

export const API_URL_AGENDA_NEED_DETAIL = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs_master/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs_master/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs_master/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs_master/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs_master/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs_master/",
);

export const API_URL_AGENDA_NEED_DELETE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs/",
);

export const API_URL_AGENDA_NEED_ADD_EDIT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs/",
);

export const API_URL_AGENDA_NEED_DUPLICATE = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs/",
);

export const API_URL_GET_AGENDA_SOLUTIONS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/agenda_solutions/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/mypage/agenda_solutions/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/agenda_solutions/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/agenda_solutions/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/agenda_solutions/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/agenda_solutions/",
);

export const API_URL_GET_AGENDA_NEEDS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/agenda_needs/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/mypage/agenda_needs/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/agenda_needs/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/agenda_needs/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/agenda_needs/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/agenda_needs/",
);

export const API_URL_GET_MATCHING_AGENDA_SOLUTIONS = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/matching/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/matching/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/matching/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/matching/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/matching/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/matching/",
);

export const API_URL_ADD_MATCHING_AGENDA_SOLUTIONS_TEACHING = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/matching/agenda_solution/add/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/matching/agenda_solution/add/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/matching/agenda_solution/add/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/matching/agenda_solution/add/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/matching/agenda_solution/add/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/matching/agenda_solution/add/",
);

export const API_URL_ADD_MATCHING_AGENDA_SOLUTIONS_NEEDS_SUGGESTION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/matching/agenda_need/add/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/matching/agenda_need/add/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/matching/agenda_need/add/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/matching/agenda_need/add/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/matching/agenda_need/add/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/matching/agenda_need/add/",
);

// api generate upload url in S3
export const API_URL_GET_UPLOAD_URL = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/generate-upload-url/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/generate-upload-url/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/generate-upload-url/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/generate-upload-url/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/generate-upload-url/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/generate-upload-url/",
);

export const API_URL_GET_DETAIL_AGENDA_NEEDS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/agenda_needs/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/agenda_needs/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/agenda_needs/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/agenda_needs/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/agenda_needs/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/agenda_needs/",
);

export const GENERATE_DISPLAY_NEED_SEED_MATCHING = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/matching/ns/{0}",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/matching/ns/{0}",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/matching/ns/{0}",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/matching/ns/{0}",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/matching/ns/{0}",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/matching/ns/{0}",
);

export const API_URL_ADD_MATCHING = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/massmatch/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/massmatch/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/massmatch/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/massmatch/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/massmatch/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/massmatch/",
);

export const API_URL_SEARCH_MATCHED = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/matched/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/matched/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/matched/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/matched/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/matched/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/matched/",
);

export const API_URL_GET_LIST_CATEGORY_NEEDS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchagendaneeds",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/searchagendaneeds",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchagendaneeds",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchagendaneeds",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchagendaneeds",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchagendaneeds",
);

export const API_URL_GET_DETAIL_MATCHING = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/matching/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/matching/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/matching/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/matching/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/matching/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/matching/",
);

export const API_URL_ADD_EVALUATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/evaluations/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/evaluations/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/evaluations/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/evaluations/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/evaluations/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/evaluations/",
);

export const API_URL_GET_LIST_POSTALS_INITIAL = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/postals/list/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/postals/list/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/postals/list/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/postals/list/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/postals/list/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/postals/list/",
);

export const API_URL_GET_LIST_POSTALS = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/postals/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/postals/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/postals/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/postals/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/postals/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/postals/",
);

// organization master
export const API_URL_SEARCH_ORGANIZATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/searchmembers/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/searchmembers/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/searchmembers/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/searchmembers/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/searchmembers/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/searchmembers/",
);
export const API_URL_ORGANIZATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/members/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/members/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/members/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/members/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/members/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/members/",
);

export const API_URL_DETAIL_ORGANIZATION = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/members/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/members/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/members/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/members/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/members/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/members/",
);

export const API_URL_GET_DETAIL_EVALUATION = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/evaluation/{0}",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/evaluation/{0}",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/evaluation/{0}",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/evaluation/{0}",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/evaluation/{0}",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/evaluation/{0}",
);

export const API_URL_GET_LIST_TITLE_APPLICATION = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/match/application/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/match/application/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/match/application/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/match/application/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/match/application/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/match/application/",
);

// chat list api

export const API_URL_GENERATE_CHAT_LIST = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/chats/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/chats/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/chats/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/chats/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/chats/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/chats/",
);

export const API_URL_GENERATE_CHAT_LIST_2 = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/chats/list/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/chats/list/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/chats/list/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/chats/list/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/chats/list/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/chats/list/",
);

export const API_URL_CHAT_STATUS = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/chats/status/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/chats/status/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/chats/status/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/chats/status/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/chats/status/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/chats/status/",
);

export const API_URL_MATCH_CHAT_DETAIL = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/match/chat/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/match/chat/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/match/chat/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/match/chat/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/match/chat/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/match/chat/",
);

// get api searcg my page chat
export const API_URL_SEARCH_MY_PAGE_CHAT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/chats",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/mypage/chats",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/chats",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/chats",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/chats",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/chats",
);

// api update implemetation date
export const API_URL_UPDATE_IMPLEMENTATION_DATE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/match/implementation_date/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/match/implementation_date/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/match/implementation_date/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/match/implementation_date/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/match/implementation_date/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/match/implementation_date/",
);
// api update match status 
export const API_URL_UPDATE_MATCH_STATUS = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/match/status/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/match/status/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/match/status/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/match/status/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/match/status/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/match/status/",
);

// api update match status my page
export const API_URL_UPDATE_MATCH_STATUS_MY_PAGE = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/match/status/mypage/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/match/status/mypage/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/match/status/mypage/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/match/status/mypage/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/match/status/mypage/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/match/status/mypage/",
);

// api update memo
export const API_URL_UPDATE_MEMO = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/match/memo/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/match/memo/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/match/memo/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/match/memo/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/match/memo/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/match/memo/",
);
// 会員主催イベント検索(POST)
export const MEMBER_EVENTS_LIST = getUrl(
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
  "https://vvvv.execute-api.ap-northeast-1.amazonaws.com/dev/memberevent/list2",
);

// Information master

// Information search(POST)
export const INFOMATION_LIST_MASTER = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information_master",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information_master",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information_master",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information_master",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information_master",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information_master",
);
// Generate Search information master(GET)
export const INFOMATION_GENERATE_SEARCH_MASTER = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchinformation",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/searchinformation",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchinformation",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchinformation",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchinformation",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchinformation",
);
// Add Edit information master(POST, PUT)
export const INFOMATION__MASTER_ADD_EDIT = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information_master/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information_master/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information_master/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information_master/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information_master/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information_master/",
);
//Generate Display Information master
export const INFOMATION_GENERATE_DISPLAY_MASTER = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information_master/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information_master/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information_master/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information_master/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information_master/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information_master/",
);
//Delete Information master(DELETE)
export const DELETE_INFOMATION_MASTER = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information/",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information/",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information/",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information/",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information/",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information/",
);

//Get list 5 recent notification (GET)
export const LIST_NEW_NOTIFICATION = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information_bell",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information_bell",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information_bell",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information_bell",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information_bell",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information_bell",
);

//count unread
export const COUNT_UNREAD = getUrl(
  "https://hbh4qr3ege.execute-api.ap-northeast-1.amazonaws.com/dev/information/unread",
  "https://m4a894xhcc.execute-api.ap-northeast-1.amazonaws.com/test/information/unread",
  "https://h82ap2yh95.execute-api.ap-northeast-1.amazonaws.com/staging/information/unread",
  "https://gw3x881sr5.execute-api.ap-northeast-1.amazonaws.com/prod/information/unread",
  "https://bzrk2cr7c5.execute-api.ap-northeast-1.amazonaws.com/demo/information/unread",
  "https://94jhktef4b.execute-api.ap-northeast-1.amazonaws.com/trial/information/unread",
);

export const GET_INDUSTRIALIZATION_REPORT = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/industrialization_report?agenda_id={0}",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/industrialization_report?agenda_id={0}",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/industrialization_report?agenda_id={0}",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/industrialization_report?agenda_id={0}",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/industrialization_report?agenda_id={0}",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/industrialization_report?agenda_id={0}",
);

export const LOGIN = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/login",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/login",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/login",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/login",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/login",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/login",
);

export const FORGOT_PASSWORD = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/forgot_password",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/forgot_password",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/forgot_password",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/forgot_password",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/forgot_password",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/forgot_password",
);

export const CONFIRM_FORGOT_PASSWORD = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/confirm_forgot_password",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/confirm_forgot_password",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/confirm_forgot_password",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/confirm_forgot_password",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/confirm_forgot_password",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/confirm_forgot_password",
);

export const GET_LANDING_IMAGE = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/landing-page/images",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/landing-page/images",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/landing-page/images",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/landing-page/images",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/landing-page/images",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/landing-page/images",
);

// case study search(POST)
export const CASE_STUDY_LIST_MASTER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/case_study",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/case_study",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/case_study",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/case_study",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/case_study",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/case_study",
);
// Generate Search case study master(GET)
export const CASE_STUDY_GENERATE_SEARCH_MASTER = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchcasestudy/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/searchcasestudy/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchcasestudy/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchcasestudy/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchcasestudy/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchcasestudy/",
);
// Add Edit case study master(POST, PUT)
export const CASE_STUDY_MASTER_ADD_EDIT = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/case_study",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/case_study",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/case_study",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/case_study",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/case_study",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/case_study",
);
//Generate Display case study master
export const CASE_STUDY_GENERATE_DISPLAY_MASTER = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/case_study/",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/case_study/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/case_study/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/case_study/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/case_study/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/case_study/",
);
//Delete case study master(DELETE)
export const DELETE_CASE_STUDY_MASTER = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/case_study/",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/case_study/",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/case_study/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/case_study/",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/case_study/",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/case_study/",
);

export const GET_INI_ADD_CASE_STUDY_DATA = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/case_study/init",
  "https://pcxwteh5x9.execute-api.ap-northeast-1.amazonaws.com/test/case_study/init",
  "https://ax7eabafn2.execute-api.ap-northeast-1.amazonaws.com/staging/case_study/init",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/case_study/init",
  "https://cnzujxetl4.execute-api.ap-northeast-1.amazonaws.com/demo/case_study/init",
  "https://vl6518059k.execute-api.ap-northeast-1.amazonaws.com/trial/case_study/init",
);

export const GET_LST_PUB_CASE_STUDY_DATA = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/case_study/list",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/case_study/list",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/case_study/list",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/case_study/list",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/case_study/list",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/case_study/list",
);

export const GET_COUNT_PUB_CASE_STUDY_DATA = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/case_study/count",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/case_study/count",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/case_study/count",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/case_study/count",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/case_study/count",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/case_study/count",
);

export const GET_LST_LANDING_CASE_STUDY_DATA = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/landing-page/case_study",
  "https://crk6crb6pi.execute-api.ap-northeast-1.amazonaws.com/test/landing-page/case_study",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/landing-page/case_study",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/landing-page/case_study",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/landing-page/case_study",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/landing-page/case_study",
);

export const API_URL_CONSULTATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/consultation/list/",
  "https://hq8nevvoyk.execute-api.ap-northeast-1.amazonaws.com/test/consultation/list/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/consultation/list/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/consultation/list/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/consultation/list/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/consultation/list/",
);

export const API_URL_CONSULTATION_ADD = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/consultation/",
  "https://hq8nevvoyk.execute-api.ap-northeast-1.amazonaws.com/test/consultation/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/consultation/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/consultation/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/consultation/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/consultation/",
);

export const API_URL_SEARCH_CONSULTATION = getUrl(
  "https://d4cgss5o60.execute-api.ap-northeast-1.amazonaws.com/dev/searchconsultation/",
  "https://ufwldkr8ca.execute-api.ap-northeast-1.amazonaws.com/test/searchconsultation/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/searchconsultation/",
  "https://hbxeg7c1r3.execute-api.ap-northeast-1.amazonaws.com/prod/searchconsultation/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/searchconsultation/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/searchconsultation/",
);

export const API_URL_CONSULTATION_DEAIL = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/consultation/",
  "https://hq8nevvoyk.execute-api.ap-northeast-1.amazonaws.com/test/consultation/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/consultation/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/consultation/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/consultation/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/consultation/",
);

export const API_URL_GET_CONSULTATION = getUrl(
  "https://o5rmculti2.execute-api.ap-northeast-1.amazonaws.com/dev/mypage/consultation/",
  "https://hq8nevvoyk.execute-api.ap-northeast-1.amazonaws.com/test/mypage/consultation/",
  "https://ig7h2ff470.execute-api.ap-northeast-1.amazonaws.com/staging/mypage/consultation/",
  "https://1q9hn0ph7a.execute-api.ap-northeast-1.amazonaws.com/prod/mypage/consultation/",
  "https://mj1gn7h438.execute-api.ap-northeast-1.amazonaws.com/demo/mypage/consultation/",
  "https://t9g3fg7zvb.execute-api.ap-northeast-1.amazonaws.com/trial/mypage/consultation/",
);

// url取得(検証、本番取得)
function getUrl(devUrl: string, testUrl: string, StagingUrl: string, prodUrl: string, DemoUrl: string, TrialUrl: string): string {
  // エンドポイント判定
  let endPoint =
    PROD_DOMAIN == window.location.host? prodUrl
      : TEST_DOMAIN == window.location.host ? testUrl
      : STAGING_DOMAIN == window.location.host ? StagingUrl
      : DEMO_DOMAIN == window.location.host ? DemoUrl
      : TRIAL_DOMAIN == window.location.host ? TrialUrl
      : devUrl;

  // エンドポイントが設定されたか否か
  if (!endPoint) {
    // エンドポイントが設定されなかった場合

    console.error(
      this.msg(
        MESSAGE_CODE.E80000,
        PROD_DOMAIN == window.location.host ? "本番用" : STAGING_DOMAIN ? "演出" : "開発用"
      )
    );

    return CONSTANT.EMPTY_STRING;
  }

  return endPoint;
}
